import { Input } from "react-aria-components";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

export function MemberProfileMedicationManagementServices() {
  return (
    <DashboardCard2
      title="Medication Management Services"
      classNameChildren="tw:flex tw:items-center tw:gap-2"
    >
      <Input checked type="checkbox" className="AddPatientInput tw:h-4" disabled />
      Medication Consult Requested
    </DashboardCard2>
  );
}
